import React from 'react';
import PropTypes from 'prop-types';
import css from './CwPodGridColumn.scss';

const CwPodGridColumn = (props) => {
  return (
    <div className={css.podGridColumn}>
      {props.children}
    </div>
  );
};

CwPodGridColumn.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ])
};

export default CwPodGridColumn;


// WEBPACK FOOTER //
// ./src/components/cwpodgrid/CwPodGridColumn.jsx